import React, { useState } from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useAppApi } from "@/App";
import { useRequest } from "@components/AppHook";
import { DevForm, FormFieldGroup } from "@components/Forms/Fields";
import { Awesome, DevModal } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function ModerateMicroreviewComplaintsScreen() {
    return (
        <DefaultLayout>
            <List />
        </DefaultLayout>
    );
}

function List() {
    const { t } = useTranslation();
    const { apiData, apiUrl, setApiReget } = useAppApi(url_reverse("api:microreview:complaints"));
    const { api_post } = useRequest();
    const [decision, setDecision] = useState({});

    if (!apiData) return;

    const updateDecision = (k, v) => {
        setDecision((prev) => ({ ...prev, [k]: v }));
    };

    const hideDecision = () => {
        setDecision({});
    };

    const doDecision = (ev) => {
        api_post(ev, apiUrl, {
            params: decision,
            then: (resp) => {
                if (resp.status === "ok") {
                    hideDecision();
                    setApiReget(true);
                }
            },
        });
    };

    return (
        <ListingCard header={t("Отзывы по играм")}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th style={{ width: "30%" }}>{t("Отзыв")}</th>
                        <th style={{ width: "30%" }}>{t("Жалоба")}</th>
                        <th>{t("Игра")}</th>
                        <th>{t("Автор")}</th>
                        <th>{t("Дата добавления")}</th>
                        <th>{t("Действия")}</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o) => (
                        <tr key={o.id}>
                            <td>
                                <div style={{ maxWidth: "500px", whiteSpace: "pre-line" }}>{o.text}</div>
                            </td>
                            <td>
                                <div style={{ maxWidth: "500px", whiteSpace: "pre-line" }}>{o.complaint_reason}</div>
                            </td>
                            <td>
                                <Link to={url_reverse("games:microreview:list", { game_id: o.game_id })}>
                                    {o.game.base_locale_object.name}
                                </Link>
                            </td>
                            <td>
                                <a
                                    href={`https://admin.vkplay.ru/admin/profiles/?user_id=${o.author_ac_id}`}
                                    target="_blank"
                                >
                                    {o.author_email}
                                </a>
                            </td>
                            <td>{o.date_added}</td>
                            <td>
                                <span className="mr-3">
                                    <Link
                                        to={url_reverse("games:microreview:edit", {
                                            game_id: o.game_id,
                                            microreview_id: o.id,
                                        })}
                                    >
                                        <Awesome type="pencil" />
                                    </Link>
                                </span>
                                <span className="mr-3">
                                    <Awesome type="bullhorn" color="red" onClick={() => updateDecision("id", o.id)} />
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <DevModal
                size="lg"
                show={decision.id}
                onHide={hideDecision}
                header={t("Решение")}
                body={
                    <>
                        <FormFieldGroup label={t("Комментарий")} required={true}>
                            <DevForm.TextArea
                                name="comment"
                                value={decision.comment}
                                required={true}
                                onChange={(ev) => updateDecision("comment", ev.target.value)}
                            />
                        </FormFieldGroup>
                        <FormFieldGroup label={t("Решение")} required={true}>
                            <DevForm.Select
                                choices={[
                                    { value: "reject", label: t("Отклонить жалобу") },
                                    { value: "hide", label: t("Скрыть отзыв") },
                                    { value: "delete", label: t("Удалить отзыв") },
                                ]}
                                value={decision.decision}
                                required={true}
                                onChange={(data) => updateDecision("decision", data.value)}
                            />
                        </FormFieldGroup>
                    </>
                }
                footer={
                    <DevForm.Button variant="primary" type="submit" name="do_decision" onClick={doDecision}>
                        {t("Подтвердить")}
                    </DevForm.Button>
                }
            />
        </ListingCard>
    );
}
